export const getUniqueName = (originalName, listOfNames, maxNameLength = 1024) => {
  const isNameUnique = name => listOfNames.every(n => n !== name);

  // Strip any existing "Copy of " prefix and trailing " (N)" suffix to get the base name
  const withoutPrefix = originalName.startsWith("Copy of ")
      ? originalName.slice("Copy of ".length)
      : originalName;
  const baseName = withoutPrefix.replace(/ \(\d+\)$/, "");

  const prefix = "Copy of ";
  let index = 0;
  let newName;

  do {
    const suffix = index === 0 ? "" : ` (${index})`;
    const availableLength = maxNameLength - prefix.length - suffix.length;
    newName = prefix + baseName.substring(0, availableLength) + suffix;
    index++;
  } while (!isNameUnique(newName));

  return newName;
};